export default __webpack_public_path__ + "static/logo_full_infill-619027f9d59bd177d4574722c4b63021.png";